module.exports = __webpack_public_path__ + "media/images/trash_hat-a1c81f65.svg";